import React, { useState, useEffect } from 'react';
import { Icon, ICONS, Loader, SuccessModal } from '@ohif/ui';
import classnames from 'classnames';
import { useNavigate, useLocation } from 'react-router-dom';
import { isValidUser } from '../Utils/authUtils';
import OtpInput from "react18-input-otp";
import { Formik, Form, ErrorMessage } from 'formik';
import './index.css';
import { _authUrls } from '@custom/Utils/constants/apiUrls';
import { maskEmail } from './helper';
import { emailVerificationValidationSchema, emailVerificationInitialValues } from './helper/schema';
import { EmailVerificationFormTypes } from './helper/auth';
import { useDispatch, useSelector } from 'react-redux';
import verifyEmailApi from '../rtk-apis/authentication/verifyEmail';
import { AppDispatch,RootState } from '../store/store';
import forgotPassword from '../rtk-apis/authentication/forgotPassword';

const EmailVerification = () => {

  const location = useLocation();
  const { email } = location?.state || {};

  const navigate = useNavigate();
  const [isSuccessModal, setSuccessModal] = useState(false)
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const dispatch = useDispatch<AppDispatch>();
  const data = useSelector((state: RootState) => state?.verifyEmail);

  const handleSubmit = async (values: EmailVerificationFormTypes) => {
    try {
      const body = {
        email: email,
        otp: +values.otp
      }
      const response = await dispatch(verifyEmailApi(body)).unwrap(); // Extract actual payload
      if(response?.msg == "Verification code not matches") {
        setApiErrorMessage('Verification code does not match.');
      }

      if (response?.status == "SUCCESS") {
        navigate('/resetPassword', {
          state: {
            email: email
          }
        });
      }
    } catch (error) {
      setApiErrorMessage('An error occurred. Please check your internet connection and try again.');
    }
  };

  const forgotPasswordData = useSelector((state: RootState) => state?.forgotPassword);

  const handleResend = async () => {
    await dispatch(forgotPassword({email: email}))
    // try {
    //   const response = await dispatch(forgotPassword({email: email})).unwrap(); // Extract actual payload

    //   if(response?.status) {
    //     setTimeLeft(120); // Reset the timer to 2 minutes
    //     setIsResendEnabled(false);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };

  useEffect(() => {
    if (isValidUser() || email === undefined) {
      navigate('/dashboard');
    }
  }, []);
  const closeModal = () => {
    setSuccessModal(false)

}

  useEffect(() => {
    if (forgotPasswordData.status === 'SUCCESS') {
        setSuccessModal(true)
            setTimeLeft(120); // Reset the timer to 2 minutes
         setIsResendEnabled(false);
    }
    else if(forgotPasswordData.status==='ERROR'){
        setApiErrorMessage('Email ID does not exists.');
             setTimeout(()=>{
            setApiErrorMessage("")
      },500)
    }
}, [forgotPasswordData?.status])

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearInterval(timerId);
    } else {
      setIsResendEnabled(true);
    }
  }, [timeLeft]);

  return (
    <>
      <div
        className={classnames("h-screen w-full bg-cover bg-no-repeat bg-center")}
        style={{
          backgroundImage: "url('/assets/BG.jpg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div className="flex justify-between items-start p-4">
          <img
            src={ICONS.SevenHillsLogo}
            alt="Seven Hills Logo"
          />
          <div
            className="flex gap-4"
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
            }}
          >
            <img
              src={ICONS.GDPR}
              style={{
                width: '100px',
                height: 'auto',
                borderRadius: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '8px',
              }}
              alt="GDPR"
            />
            <img
              src={ICONS.Hippa}
              style={{
                width: '120px',
                height: 'auto',
                borderRadius: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '8px',
              }}
              alt="HIPAA"
            />
          </div>
        </div>
      <div className={classnames("login-container w-[400px] h-[420px] p-6 bg-white text-black m-0 mx-auto rounded-lg transform -translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 border border-gray-300 shadow-lg")}>
        <div className={classnames("flex flex-col justify-center items-center mb-4")}>
          <img className='w-14 h-14 mb-2' src={`${ICONS.Envelop_Icon}`} alt="Envelop_Icon" />
          <h1 className={classnames('text-black font-semibold text-xxl text-[#49475A]')}>Enter a verification code</h1>
        </div>
        <div className="flex flex-col justify-center items-center my-2 w-full">
          <p className={classnames('text-gray font-normal text-sm w-full text-center')}>
            Email with a verification code was just sent to
            <span className={classnames('text-black font-normal text-sm')} style={{ color: '#0F8491'}} > {maskEmail(email)}</span>
          </p>
          <p className={classnames('text-black font-semibold text-sm mt-2')}>
            Type your 6 digit security code
          </p>
        </div>
        <Formik
          initialValues={emailVerificationInitialValues}
          validationSchema={emailVerificationValidationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange }) => (
            <Form>
              <div className={classnames("flex flex-col items-center text-center gap-[3px] my-[15px]")}>
                <OtpInput
                  id='otp'
                  value={values.otp}
                  isInputNum
                  onChange={(otp) => handleChange({ target: { name: 'otp', value: otp } })}
                  numInputs={6}
                  shouldAutoFocus
                  className="otp-container" // Apply some CSS to style it properly if needed
                />
                <ErrorMessage name="otp" component="div" className="text-red-500 text-sm" />
              </div>
              <div className='mt-5 w-full mb-1'>
                <button type="submit" style={{ backgroundColor: '#0F8491' }} className='rounded-md w-full p-2 bg-primary text-white'>
                  Verify
                </button>
              </div>
              {apiErrorMessage && (
                <p className="text-red-500 font-normal text-sm text-center">
                  {apiErrorMessage}
                </p>
              )}
            </Form>
          )}
        </Formik>
        <p className={classnames('text-gray font-normal text-sm w-full text-center mt-4')}>
          Didn't get the code?
          <span className="mx-1">{timeLeft > 0 ? `Resend in ${Math.floor(timeLeft / 60)}:${timeLeft % 60}` : ''}</span>
        </p>
        <p
          className={classnames('text-[#0F8491] font-normal text-sm w-full text-center mt-1', {'cursor-pointer': isResendEnabled}, { 'opacity-50 cursor-not-allowed': !isResendEnabled })}
          onClick={isResendEnabled ? handleResend : null}
        >
          Resend Code
        </p>
        <div className='flex justify-center items-center p-2 text-[#49475A] mt-2 pb-0'>
          <Icon name='chevron-left' className="text-gray-600" />
          <button onClick={() => navigate('/login')}>
              Back to Login
          </button>
        </div>
      </div>
      <div className="text-center text-sm text-[#0F8491] mt-4">
        © 2025 Svensa Solutions LLC, UAE - Svensa Images. <br />
        All rights reserved.
      </div>
    </div>
    <Loader isLoaderOpen={data.loading}></Loader>
    <SuccessModal isSuccessModalOpen={isSuccessModal} title={data?.msg} handleCloseModal={closeModal} />
    </>
  );
};

export default EmailVerification;
